import { render, staticRenderFns } from "./InspectionLayout.vue?vue&type=template&id=0ca5e3b4"
import script from "./InspectionLayout.vue?vue&type=script&lang=ts"
export * from "./InspectionLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports